import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const TLE_URL = "https://truelifeentertainment.com";

export default function ParentCompany() {
  return (
    <section
      className="relative border-t border-brand-purple/15 bg-[#07030f] py-16"
      data-testid="parent-company-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="flex justify-center">
          <a
            href={TLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="parent-company-link"
            className="group inline-flex flex-col items-center gap-3 rounded-full border border-brand-purple/25 bg-white/[0.03] px-8 py-5 text-center transition-all duration-300 hover:border-brand-purple/60 hover:bg-brand-purple/10 hover:shadow-[0_0_40px_rgba(140,82,255,0.25)] sm:flex-row sm:gap-5"
          >
            <span className="text-[11px] font-bold uppercase tracking-[0.24em] text-brand-mist/55">
              Lantix is a product of
            </span>
            <span className="font-display text-lg font-bold tracking-[0.08em] text-brand-paper sm:text-xl">
              TRUE LIFE ENTERTAINMENT<span className="text-brand-gold">.</span>
            </span>
            <ArrowUpRight className="h-4 w-4 text-brand-teal transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
